(function () {
  /* ---------- add to cart (drawer-aware, no reload off the cart page) ---------- */
  function ciShowAddError(button) {
    if (!button || !button.closest) return;
    try {
      var host = button.closest('.ci-set, .ci-dupsell, .ci-addons__item, .ci-bundle__card') || button.parentNode;
      var note = host.querySelector('.ci-add-error');
      if (!note) {
        note = document.createElement('span');
        note.className = 'ci-add-error';
        note.setAttribute('role', 'alert');
        host.appendChild(note);
      }
      note.textContent = 'Couldn’t add. Try again.';
      setTimeout(function () { if (note.parentNode) note.parentNode.removeChild(note); }, 4000);
    } catch (e) {}
  }
  // Adds run one at a time: parallel responses can resolve out of order and
  // paint a stale drawer state.
  var ciAddQueue = Promise.resolve();
  function ciAddItemsToCart(variantIds, button) {
    var origText;
    if (button) {
      button.disabled = true;
      origText = button.textContent;
      button.textContent = 'Adding…';
    }
    function run() {
      var drawer = document.querySelector('cart-drawer');
      var onCartPage = window.location.pathname.indexOf('/cart') !== -1;
      var body = {
        items: variantIds.map(function (id) { return { id: Number(id), quantity: 1 }; })
      };
      if (drawer && !onCartPage && typeof drawer.getSectionsToRender === 'function') {
        body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
      }
      return fetch((window.routes && window.routes.cart_add_url || '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status && data.status !== 200) throw new Error(data.description || 'Add failed');
          if (drawer && !onCartPage && typeof drawer.renderContents === 'function') {
            // The item is in the cart by this point — a render failure is not
            // an add failure, so recover with a reload, not "Couldn't add".
            try { drawer.renderContents(data); } catch (e) { window.location.reload(); }
          } else {
            window.location.reload();
          }
        })
        .catch(function () { ciShowAddError(button); })
        .finally(function () {
          if (button) {
            button.disabled = false;
            if (origText) button.textContent = origText;
          }
        });
    }
    ciAddQueue = ciAddQueue.then(run, run);
    return ciAddQueue;
  }
  function ciAddToCart(variantId, button) {
    return ciAddItemsToCart([variantId], button);
  }
  window.ciAddToCart = ciAddToCart;
  window.ciAddItemsToCart = ciAddItemsToCart;

  /* v4.9: the old JS free-shipping meter is GONE. The drawer status line is Liquid
     (cart-drawer.liquid, one mutually-exclusive line per v4.4) and every cart change
     re-renders the section, so a JS overlay is not just redundant, it was overwriting
     the owner-approved copy with the stale v4.0 meter on every cart mutation. */

  /* nav drawer open state as a body class: replaces a body:has() rule, because the
     Shopify CDN CSS minifier strips :has() from served assets. */
  (function () {
    function wire() {
      var d = document.getElementById('Details-menu-drawer-container');
      if (!d) return;
      var sync = function () { document.body.classList.toggle('ci-nav-open', d.hasAttribute('open')); };
      new MutationObserver(sync).observe(d, { attributes: true, attributeFilter: ['open'] });
      sync();
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', wire);
    else wire();
  })();

  /* ---------- sticky add-to-bag (price + availability stay in sync) ---------- */
  function initStickyAtb() {
    var submit = document.querySelector('.product-form__submit');
    if (!submit || document.querySelector('.ci-sticky-atb')) return;
    var priceEl = document.querySelector('.product__info-container .price__regular .price-item, .product__info-container .price-item--regular');
    var bar = document.createElement('div');
    bar.className = 'ci-sticky-atb';
    bar.innerHTML = '<span class="ci-sticky-atb__price"></span><button type="button" class="ci-sticky-atb__btn"></button>';
    document.body.appendChild(bar);
    var barPrice = bar.querySelector('.ci-sticky-atb__price');
    var barBtn = bar.querySelector('button');

    function sync() {
      barPrice.textContent = priceEl ? priceEl.textContent.trim() : '';
      var label = (submit.querySelector('span') || submit).textContent.trim();
      barBtn.textContent = label || 'Add To Bag';
      barBtn.disabled = submit.disabled || submit.getAttribute('aria-disabled') === 'true';
    }
    sync();

    var container = document.querySelector('.product__info-container') || document.body;
    var syncQueued = false;
    new MutationObserver(function () {
      if (syncQueued) return;
      syncQueued = true;
      requestAnimationFrame(function () {
        syncQueued = false;
        priceEl = document.querySelector('.product__info-container .price__regular .price-item, .product__info-container .price-item--regular');
        submit = document.querySelector('.product-form__submit') || submit;
        sync();
      });
    }).observe(container, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });

    barBtn.addEventListener('click', function () {
      submit.click();
    });
    function setBarVisible(visible) {
      bar.classList.toggle('is-visible', visible);
      bar.inert = !visible;
    }
    setBarVisible(false);
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        setBarVisible(!entries[0].isIntersecting);
      }, { threshold: 0 });
      io.observe(submit);
    } else {
      setBarVisible(true);
    }
  }

  /* ---------- drop countdowns ---------- */
  function initCountdowns() {
    document.querySelectorAll('[data-ci-countdown]').forEach(function (el) {
      var target = new Date(el.getAttribute('data-ci-countdown')).getTime();
      if (isNaN(target)) return;
      if (el.dataset.ciCountdownInit) return;
      el.dataset.ciCountdownInit = '1';
      function pad(n) { return String(n).padStart(2, '0'); }
      function seg(v, u) {
        return '<span class="ci-cd-seg"><span class="ci-cd-seg__num">' + pad(v) + '</span><span class="ci-cd-seg__unit">' + u + '</span></span>';
      }
      var timer;
      function tick() {
        var d = Math.max(0, target - Date.now());
        var s = Math.floor(d / 1000);
        var days = Math.floor(s / 86400);
        var hours = Math.floor((s % 86400) / 3600);
        if (d === 0) {
          el.innerHTML = '<span class="ci-cd-live">LIVE NOW</span>';
          el.setAttribute('aria-label', 'The drop is live now');
          if (timer) clearInterval(timer);
          return;
        }
        el.innerHTML = seg(days, 'DAYS') + seg(hours, 'HRS') + seg(Math.floor((s % 3600) / 60), 'MIN') + seg(s % 60, 'SEC');
        el.setAttribute('aria-label', 'Next drop in ' + days + ' days ' + hours + ' hours');
      }
      tick();
      timer = setInterval(tick, 1000);
    });
  }

  /* ---------- PDP gallery: gentle auto-advance on desktop ---------- */
  function initGalleryTicker() {
    if (!window.matchMedia('(min-width: 990px)').matches) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var gallery = document.querySelector('media-gallery');
    if (!gallery || gallery.dataset.ciTicker) return;
    var thumbs = [].slice.call(gallery.querySelectorAll('.thumbnail-list__item .thumbnail'));
    if (thumbs.length < 2) return;
    gallery.dataset.ciTicker = '1';
    var timer = null;
    var inView = true;
    function currentIdx() {
      for (var i = 0; i < thumbs.length; i++) {
        if (thumbs[i].getAttribute('aria-current') === 'true') return i;
      }
      return 0;
    }
    function tick() { thumbs[(currentIdx() + 1) % thumbs.length].click(); }
    function start() {
      if (gallery.dataset.ciTicker !== '1' || document.hidden || !inView) return;
      if (!timer) timer = setInterval(tick, 4500);
    }
    function pause() { if (timer) { clearInterval(timer); timer = null; } }
    gallery.addEventListener('mouseenter', pause);
    gallery.addEventListener('mouseleave', start);
    // any manual interaction hands control back to the customer for good;
    // keyboard users get a still gallery the moment focus enters it
    gallery.addEventListener('pointerdown', function () { gallery.dataset.ciTicker = 'off'; pause(); }, true);
    gallery.addEventListener('focusin', function () { gallery.dataset.ciTicker = 'off'; pause(); });
    // stop pulling ~2000px frames in a hidden tab or off-screen
    document.addEventListener('visibilitychange', function () { document.hidden ? pause() : start(); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        inView = entries[0].isIntersecting;
        if (inView) { start(); } else { pause(); }
      }, { threshold: 0.1 }).observe(gallery);
    }
    start();
  }

  function initUpsellDelegation() {
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      var chip = e.target.closest('[data-ci-upsell-size]');
      if (chip) {
        var row = chip.closest('[data-ci-upsell-row]');
        if (!row) return;
        row.querySelectorAll('[data-ci-upsell-size]').forEach(function (x) { x.classList.toggle('is-active', x === chip); });
        var add = row.querySelector('[data-ci-upsell-add]');
        if (add) {
          add.setAttribute('data-variant', chip.getAttribute('data-variant'));
          add.disabled = false;
        }
        return;
      }
      var btn = e.target.closest('[data-ci-upsell-add]');
      if (btn && !btn.disabled && btn.getAttribute('data-variant')) ciAddToCart(btn.getAttribute('data-variant'), btn);
    });
  }

  /* ---------- shop-the-set bundles (size chips + one-call multi add) ---------- */
  function initBundleDelegation() {
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      var chip = e.target.closest('[data-ci-bundle-size]');
      if (chip) {
        var item = chip.closest('[data-ci-bundle-item]');
        if (!item) return;
        item.querySelectorAll('[data-ci-bundle-size]').forEach(function (x) {
          var on = x === chip;
          x.classList.toggle('is-active', on);
          x.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        item.setAttribute('data-selected', chip.getAttribute('data-variant'));
        var card = chip.closest('[data-ci-bundle]');
        if (!card) return;
        var add = card.querySelector('[data-ci-bundle-add]');
        if (add) {
          add.disabled = card.querySelectorAll('[data-ci-bundle-item][data-selected]').length !== card.querySelectorAll('[data-ci-bundle-item]').length;
        }
        return;
      }
      var btn = e.target.closest('[data-ci-bundle-add]');
      if (btn && !btn.disabled) {
        var host = btn.closest('[data-ci-bundle]');
        if (!host) return;
        var ids = [];
        host.querySelectorAll('[data-ci-bundle-item][data-selected]').forEach(function (it) {
          ids.push(it.getAttribute('data-selected'));
        });
        if (ids.length) ciAddItemsToCart(ids, btn);
      }
    });
  }

  /* ---------- members popup (10% off + 24hr early access) ---------- */
  function initMembersPopup() {
    var pop = document.querySelector('dialog[data-ci-popup]');
    if (!pop || typeof pop.showModal !== 'function' || pop.dataset.ciPopupInit === '1') return;
    pop.dataset.ciPopupInit = '1';
    var KEY = 'ci_members_popup';
    function read() {
      try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { return null; }
    }
    function mark(state) {
      try { localStorage.setItem(KEY, JSON.stringify({ at: Date.now(), state: state })); } catch (e) {}
    }
    function dismiss() {
      mark('dismissed');
      if (pop.open) pop.close();
    }
    pop.querySelectorAll('[data-ci-popup-close]').forEach(function (b) { b.addEventListener('click', dismiss); });
    pop.addEventListener('cancel', function () { mark('dismissed'); });
    pop.addEventListener('click', function (e) { if (e.target === pop) dismiss(); });

    // Theme editor: open/close with section selection, never auto-fire.
    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:select', function (e) {
        if (e.target.contains(pop)) { try { pop.showModal(); } catch (err) {} }
      });
      document.addEventListener('shopify:section:deselect', function (e) {
        if (e.target.contains(pop) && pop.open) pop.close();
      });
      return;
    }

    // Shopify marks every customer form as posted after any signup, but it
    // anchors the redirect to the posting form's id — only reopen the popup
    // when its own form was the poster.
    var postedHere = window.location.hash === '#ci-members-popup';
    // Signed up through the popup → reopen with the success state, then stay
    // quiet forever. Signed up elsewhere → count as joined silently.
    if (pop.querySelector('[data-ci-popup-success]')) {
      mark('joined');
      if (postedHere) { try { pop.showModal(); } catch (e) {} }
      return;
    }
    // Popup form errored (e.g. bad email) → reopen so the message isn't lost.
    // Errors from other forms stay theirs.
    if (pop.querySelector('[data-ci-popup-error]')) {
      if (postedHere) { try { pop.showModal(); } catch (e) {} }
      return;
    }
    // Signed up via any other customer form (band / drop-launch) → treat as joined.
    if (window.location.search.indexOf('customer_posted=true') !== -1) {
      mark('joined');
      return;
    }

    var prev = read();
    if (prev) {
      if (prev.state === 'joined') return;
      var days = parseFloat(pop.getAttribute('data-days')) || 7;
      if (Date.now() - prev.at < days * 86400000) return;
    }
    var delay = (parseFloat(pop.getAttribute('data-delay')) || 20) * 1000;
    var fired = false;
    function consentBannerVisible() {
      var b = document.getElementById('shopify-pc__banner');
      if (!b) return false;
      var r = b.getBoundingClientRect();
      return r.width > 0 && r.height > 0 && getComputedStyle(b).visibility !== 'hidden';
    }
    function bandInView() {
      var band = document.querySelector('.ci-band');
      if (!band) return false;
      var r = band.getBoundingClientRect();
      return r.bottom > 0 && r.top < window.innerHeight;
    }
    function tryShow() {
      if (fired) return;
      // Never interrupt an open drawer/modal — skip this pageview instead.
      if (document.querySelector('dialog[open]')) return;
      var drawer = document.querySelector('cart-drawer');
      if (drawer && (drawer.classList.contains('active') || drawer.classList.contains('animate'))) return;
      var menu = document.getElementById('Details-menu-drawer-container');
      if (menu && menu.hasAttribute('open')) return;
      if (consentBannerVisible()) return;
      // The band asks for the same email — never double up while it's on screen.
      if (bandInView()) return;
      fired = true;
      try { pop.showModal(); } catch (e) {}
    }
    var armed = false;
    function arm() {
      if (armed || fired) return;
      armed = true;
      if (!consentBannerVisible()) { tryShow(); return; }
      // The cookie banner gets first touch: wait for the visitor's decision
      // (accept or decline both count), then give them a short breather.
      var GRACE = 4000;
      document.addEventListener('visitorConsentCollected', function () {
        setTimeout(tryShow, GRACE);
      }, { once: true });
      var poll = setInterval(function () {
        if (!consentBannerVisible()) {
          clearInterval(poll);
          setTimeout(tryShow, GRACE);
        }
      }, 1000);
      setTimeout(function () { clearInterval(poll); }, 180000);
    }
    // Two triggers, first one wins: the delay timer, or half a page of scroll.
    setTimeout(arm, delay);
    function scrollDepth() {
      var doc = document.documentElement;
      var max = doc.scrollHeight - window.innerHeight;
      if (max <= 0) return 0;
      return (window.scrollY || doc.scrollTop || 0) / max;
    }
    window.addEventListener('scroll', function onScroll() {
      if (fired || armed) { window.removeEventListener('scroll', onScroll); return; }
      if (scrollDepth() >= 0.5) {
        window.removeEventListener('scroll', onScroll);
        arm();
      }
    }, { passive: true });
  }

  function init() {
    initStickyAtb();
    initCountdowns();
    initGalleryTicker();
    initUpsellDelegation();
    initBundleDelegation();
    initMembersPopup();
    // Re-init dynamic sections when (re)rendered in the theme editor.
    document.addEventListener('shopify:section:load', function () {
      initCountdowns();
      initMembersPopup();
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
/* CI Model Tag — delegated toggle (survives section re-renders) */
(function () {
  function ciModelTagCloseAll(except) {
    document.querySelectorAll('[data-ci-model-tag].is-open').forEach(function (root) {
      if (root === except) return;
      root.classList.remove('is-open');
      var card = root.querySelector('.ci-model-tag__card');
      var btn = root.querySelector('[data-ci-model-tag-toggle]');
      if (card) card.hidden = true;
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  }
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-ci-model-tag-toggle]');
    if (toggle) {
      var root = toggle.closest('[data-ci-model-tag]');
      var card = root.querySelector('.ci-model-tag__card');
      var open = root.classList.contains('is-open');
      ciModelTagCloseAll(root);
      root.classList.toggle('is-open', !open);
      if (card) card.hidden = open;
      toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
      return;
    }
    if (!e.target.closest('[data-ci-model-tag]')) ciModelTagCloseAll();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelector('[data-ci-model-tag].is-open [data-ci-model-tag-toggle]');
    ciModelTagCloseAll();
    if (open) open.focus();
  });
})();

/* ---------- card quick add: hover size row (desktop) + plus sheet (mobile) ---------- */
(function () {
  var sheet, backdrop, lastFocus;
  function ensureSheet() {
    if (sheet) return;
    backdrop = document.createElement('div');
    backdrop.className = 'ci-qa-backdrop';
    sheet = document.createElement('div');
    sheet.className = 'ci-qa-sheet';
    sheet.setAttribute('role', 'dialog');
    sheet.setAttribute('aria-modal', 'true');
    sheet.setAttribute('aria-label', 'Choose a size');
    sheet.innerHTML = '<p class="ci-qa-sheet__title"></p><p class="ci-qa-sheet__hint">Select a size</p><div class="ci-qa__sizes"></div>';
    document.body.appendChild(backdrop);
    document.body.appendChild(sheet);
    backdrop.addEventListener('click', closeQaSheet);
  }
  function openQaSheet(card) {
    var qa = card && card.querySelector('[data-ci-qa]');
    if (!qa) return;
    ensureSheet();
    sheet.querySelector('.ci-qa-sheet__title').textContent = qa.getAttribute('data-title') || '';
    sheet.querySelector('.ci-qa__sizes').innerHTML = qa.querySelector('.ci-qa__sizes').innerHTML;
    lastFocus = document.activeElement;
    backdrop.classList.add('is-open');
    sheet.classList.add('is-open');
    var first = sheet.querySelector('.ci-qa__size:not([disabled])');
    if (first) first.focus();
  }
  function closeQaSheet() {
    if (!sheet || !sheet.classList.contains('is-open')) return;
    backdrop.classList.remove('is-open');
    sheet.classList.remove('is-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var plus = e.target.closest('[data-ci-qa-plus]');
    if (plus) {
      e.preventDefault();
      openQaSheet(plus.closest('.card'));
      return;
    }
    var size = e.target.closest('.ci-qa__size');
    if (size && !size.disabled && size.getAttribute('data-variant') && window.ciAddToCart) {
      e.preventDefault();
      window.ciAddToCart(size.getAttribute('data-variant'), size);
      if (sheet && sheet.classList.contains('is-open')) setTimeout(closeQaSheet, 350);
    }
  });
  document.addEventListener('pointerdown', function (e) {
    // Outside-tap dismiss. The backdrop's click listener covers this on desktop, but
    // iOS webviews (Instagram in-app browser) don't reliably synthesize that click, so
    // close on the earlier pointerdown and swallow the tap's click so it can't fall
    // through to whatever is under the backdrop.
    if (!sheet || !sheet.classList.contains('is-open')) return;
    if (e.target.closest && (e.target.closest('.ci-qa-sheet') || e.target.closest('[data-ci-qa-plus]'))) return;
    closeQaSheet();
    var swallow = function (ev) { ev.preventDefault(); ev.stopPropagation(); };
    document.addEventListener('click', swallow, { capture: true, once: true });
    setTimeout(function () { document.removeEventListener('click', swallow, true); }, 500);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeQaSheet();
  });
})();

/* ---------- v4.9: desktop hover intent for card quick add. Overlay opens only from the
   product image (or the open overlay itself), never from the title area. A JS-managed
   class, because Shopify's CDN CSS minifier strips :has() rules. Gated on
   pointerType === 'mouse', NOT media queries: Instagram's iOS in-app browser reports
   (hover:hover), so the synthetic mouseover fired on every tap there, opened the overlay
   and swallowed the tap that should have navigated to the product page. ---------- */
(function () {
  function closeAll(except) {
    document.querySelectorAll('.card.is-qa-open').forEach(function (c) {
      if (c !== except) c.classList.remove('is-qa-open');
    });
  }
  document.addEventListener('pointerover', function (e) {
    if (e.pointerType !== 'mouse' || !e.target.closest) return;
    var inner = e.target.closest('.card__inner');
    var qa = e.target.closest('.ci-qa');
    var keep = inner ? inner.closest('.card') : qa ? qa.closest('.card') : null;
    if (keep && !keep.querySelector('[data-ci-qa]')) keep = null;
    closeAll(keep);
    if (keep) keep.classList.add('is-qa-open');
  });
  document.addEventListener('pointerout', function (e) {
    if (e.pointerType === 'mouse' && !e.relatedTarget) closeAll(null);
  });
})();
